import axiosInstance from '../../../lib/axios';

export const getChallenges = async () => {
  const response = await axiosInstance.get('/challenges');
  return response.data;
};

export const getChallenge = async (id) => {
  const response = await axiosInstance.get(`/challenges/${id}`);
  return response.data;
};

export const submitChallengeResponse = async (id, response) => {
  const res = await axiosInstance.post(`/challenges/${id}/submit`, { response });
  return res.data;
};

export const getChallengeApproach = async (id) => {
  const response = await axiosInstance.get(`/challenges/${id}/approach`);
  return response.data;
};

export const getMyChallengeSubmissions = async (id) => {
  const response = await axiosInstance.get(`/challenges/${id}/my-submissions`);
  return response.data;
};

export const makeCaseChallenge = async (caseId) => {
  const response = await axiosInstance.patch(`/cases/${caseId}/make-challenge`);
  return response.data;
};
